import type { WebapiEndpointBuilder } from '@/api/webapi.ts';
import { WORKSPACE_VERSION } from '@/api/workspace';
import { type ValidatedWorkspaceForex, validateWorkspace } from '@/api/workspace/endpoints/validateWorkspace.ts';
import type { Workspace } from '@/api/workspace/model.ts';

export const getWorkspace = (builder: WebapiEndpointBuilder) =>
  builder.query<ValidatedWorkspaceForex | undefined, void>({
    query: () => ({
      url: `/userdata/workspaceForex/${WORKSPACE_VERSION}`,
      method: 'GET',
    }),
    transformResponse,
  });

function transformResponse(workspace: Workspace | null | undefined): ValidatedWorkspaceForex | undefined {
  return validateWorkspace(workspace) ?? undefined;
}
